module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-02.27cd72193be18655f7e34039a19ab7ad.png";